<template>
  <div class="tw-mt-4">
    <div v-if="isLoading">Loading...</div>
    <div v-else-if="tickets.length === 0">Geen tickets voor dit adres</div>

    <div v-for="group in groupedTickets" :key="group.key">
      <div
        v-if="groupedTickets.length > 1"
        class="tw-text-xs tw-font-bold tw-text-gray-500 tw-mb-1 tw-mt-2"
      >
        {{ group.name }}
      </div>
      <SmallTicketListItem v-for="ticket in group.tickets" :key="ticket.id" :ticket="ticket" />
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useAddressTickets } from './composables/useAddressTickets'
import useConfigProjects from '@/util/useConfigProjects'
import SmallTicketListItem from '@/components/shared/SmallTicketListItem.vue'

const props = defineProps({
  address: String,
})

const { data: tickets, isLoading } = useAddressTickets(computed(() => props.address))

const { projectNamesById } = useConfigProjects()

// Group tickets per project; tickets carry their project_id
const groupedTickets = computed(() => {
  const groups = {}
  for (const ticket of tickets.value || []) {
    const key = ticket.project_id ?? 'none'
    if (!groups[key]) {
      groups[key] = {
        key,
        name:
          ticket.project_id != null
            ? projectNamesById.value[ticket.project_id] || `Project ${ticket.project_id}`
            : 'Zonder project',
        tickets: [],
      }
    }
    groups[key].tickets.push(ticket)
  }
  return Object.values(groups)
})
</script>
